const { INLINE_PERMISSIONS, CREATE_UPDATE_PERMISSINS, DELETED_PERMISSIONS } = require('../const');

// Function to check if userPermissions exactly match allPermissions
export const checkPermissionHas = (userPermissions) => {
  // Group all permissions into one array for easier comparison
  const allPermissions = [
    ...INLINE_PERMISSIONS.map(permission => permission.value),
    ...CREATE_UPDATE_PERMISSINS.map(permission => permission.value),
    ...DELETED_PERMISSIONS.map(permission => permission.value),
  ];

  // Check if the length is the same
  if (userPermissions.length !== allPermissions.length) {
    return false;
  }


  // Sort both arrays to compare in order
  const userPermissionValues = userPermissions.map(permission => permission).sort();
  const allPermissionsSorted = allPermissions.sort();

  // Check if the sorted arrays are identical
  return userPermissionValues.every((value, index) => value === allPermissionsSorted[index]);
};

// module.exports = { checkPermissionHas };
